
import { DateTimePickerView } from "./datetimepickerview";
import { DateTimePickerCSSStyleImpl } from "./datetimepickercss";
import * as moment from 'moment';

import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { UIComponentCSSStyle } from '../uicomponentcss';

export interface DateTimePickerProps extends UIComponentProps
{
    id: string;
    label:string;
    value: any;
    placeholder: string;
    inputType: string;
    isRequired: boolean;
    emptyErrorMsg: string;
    isDisabled:boolean;
    format:string;
    autocomplete?:string;
    onChange(data:string):void;
    onKeyPress(e:React.KeyboardEvent):void;
    
   
}

export interface DateTimePickerState extends UIComponentState{
    value:any;  
    errorMessage:string|undefined;
}

export interface DateTimePickerHandler extends UIComponentHandler{
    onChange(data:string):void;
}

export class DateTimePickerComponent extends UIComponentImpl<DateTimePickerProps, 
DateTimePickerState, UIDataModel> implements DateTimePickerHandler{
    



    constructor(textprops: DateTimePickerProps){
        super(textprops);

        this.state = {value: this.props.value === "" ? "" :
        this.convertToStandardTime(this.props.value), errorMessage: undefined};


    }
   

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DateTimePickerView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DateTimePickerCSSStyleImpl(applicationContext);
    }

    
    // //
    // UNSAFE_componentWillReceiveProps(newProps:DateTimePickerProps){
    //     this.setState({value: newProps.value});
    // }
    setErrorMessage(errorMesssage: string)
    {
        this.setState({errorMessage: errorMesssage});
    }

    
    onChange(data: any): void 
    {
        if (data !== '') {
            this.setState({value: data});
        }
        else {
                this.setState({value: data});
        }
    }

    
    clearData()
    {
        this.setState({value: "", errorMessage: undefined});
    }

    validate(): boolean
    {
        if(this.props.isRequired && this.state.value.length === 0)
        {
            this.setState({errorMessage: this.props.emptyErrorMsg});

            return false;
        }
        else
        {
            this.setState({errorMessage: undefined});

            return true;
        }
    }


   //

   

    getData()
    {
        // let dateTime = moment(this.state.value,'DD/MM/yyyy hh:mm');
        let dateTime = moment( this.state.value, 'DD/MM/YYYY HH:mm a',true).format("DD/MM/YYYY HH:mm");
        
        return dateTime;
    }

    // clearData()
    // {
    //     this.setState({value: "", errorMessage: undefined});
    // }

    // validate(): boolean
    // {
    //     let validationModel:any = 
    //     this.props.propertyModel.isValid(this.state.data === null ? "" : this.state.data);

    //     if(!validationModel.isValid())
    //     {
    //         this.setState({errorMessage: validationModel.getMessage()});
    //     }else{
    //         this.setState({errorMessage: undefined});
    //     }

    //     return validationModel.isValid();
    // }

    toggleComponent(canShow: any)
    {
            this.forceUpdate();
    }

    updateDataChange(isChecked: boolean)
    {
    }

    private convertToStandardTime(utcDate:string) 
    {
        var formattedData = moment(utcDate, this.props.format);

        return formattedData.toDate();
        
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/datetimepicker/datetimepicker.tsx